import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  get_candidate_profile_data_action,
  update_user_meta_data_action,
  get_candidate_accepted_interviews_action,
  get_candidate_assigned_assessment_kits_data_action,
  get_candidate_interview_invites_action,
} from "../../../redux/_actions";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";
import { appRoutes } from "../../../_routes/app-routes";

function useCandidateDashboard(props) {
  const [candidateProfile, setCandidateProfile] = useState(null);
  const [assignedAssessmentKits, setAssignedAssessmentKits] = useState([]);
  const [assignAssesmentKitsLoading, setAssignedAssessmentKitsLoading] =
    useState(false);
  const [resumeUploadModal, setResumeUploadModal] = useState(false);
  const [scheduledInterviews, setScheduledInterviews] = useState([]);
  const [scheduledInterviewsLoading, setScheduledInterviewsLoading] =
    useState(false);
  const [interviewInvites, setInterviewInvites] = useState([]);
  const [interviewInvitesLoading, setInterviewInvitesLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  //get data from redux
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  const { acceptedInterviewData } = useSelector(
    (state) => state.get_candidate_accepted_interviews_reducer
  );

  const { candidateAssignedAssessmentsData } = useSelector(
    (state) => state.get_candidate_assigned_assessment_kits_data_reducer
  );
  const { interviewInvitesData } = useSelector(
    (state) => state.get_candidate_interview_invites_reducer
  );


  useEffect(() => {
    callCandidateDetailsApi();
    callAssessmentKitsApi();
    callScheduledInterviewsApi();
    callInterviewInvitesApi();
  }, []);

  useEffect(() => {
    if (userProfileData?.data) {
      setCandidateProfile(userProfileData?.data);
    }
  }, [userProfileData]);

  useEffect(() => {
    if (candidateAssignedAssessmentsData) {
      setAssignedAssessmentKits(candidateAssignedAssessmentsData);
    }
  }, [candidateAssignedAssessmentsData]);

  useEffect(() => {
    if (acceptedInterviewData?.data) {
      setScheduledInterviews(
        acceptedInterviewData?.data && acceptedInterviewData?.data.results
      );
    }
  }, [acceptedInterviewData]);
  useEffect(() => {
    if (interviewInvitesData?.data) {
      setInterviewInvites(
        interviewInvitesData?.data && interviewInvitesData?.data.results
      );
    }
  }, [interviewInvitesData]);

  // call initial apis
  const callAssessmentKitsApi = async () => {
    setAssignedAssessmentKitsLoading(true);
    await dispatch(get_candidate_assigned_assessment_kits_data_action());
    setAssignedAssessmentKitsLoading(false);
  };

  const callInterviewInvitesApi = async () => {
    setInterviewInvitesLoading(true);
    await dispatch(get_candidate_interview_invites_action());
    setInterviewInvitesLoading(false);
  };


  const callCandidateDetailsApi = async () => {
    await dispatch(get_candidate_profile_data_action());
  };

  const callScheduledInterviewsApi = async () => {
    setScheduledInterviewsLoading(true);
    await dispatch(get_candidate_accepted_interviews_action());
    setScheduledInterviewsLoading(false);
  };

  const onShareProfileClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000/view-candidate-profile/${
          candidateProfile?.user_details &&
          candidateProfile.user_details?.hash_id
        }`
      : `${process.env.REACT_APP_DEV_ROOT_URL}/view-candidate-profile/${
          candidateProfile?.user_details &&
          candidateProfile.user_details?.hash_id
        }`;
    window.navigator.clipboard.writeText(url);

    showSuccessMessage(`Url copied ${url}`);
  };

  const onViewAssessmentDetailsClick = (interviewKit, jobPosting) => {
    navigate(
      `/assigned-interview-kit?appliedJob=${jobPosting}&interviewKit=${interviewKit}`
    );
  };

  const onStartAssessmentClick = (interviewKit, jobPosting) => {
    navigate(
      `/interview-instructions?interviewKit=${interviewKit}&appliedJob=${jobPosting}`
    );
  };

  const viewScheduleCalenderHandler = (id, applicantId) => {
    if (id) {
      if (applicantId)
        navigate(
          `/schedule-interview?event_link=${id}&applicant=${applicantId}`
        );
      else showWarningMessage("Candidate Id not found");
    } else navigate(`/schedule-interview?event_link=${id}`);
  };

  const calculatePercentage = (answered_ques_count, total_questions) => {
    const calculatedValue =
      parseInt((answered_ques_count / total_questions) * 100).toFixed(2) + "%";

    return calculatedValue;
  };

  const handleResumeUploadModal = (type) => {
    setResumeUploadModal(type);
  };

  const onResumeUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        await dispatch(update_user_meta_data_action(data));
        callCandidateDetailsApi();
        handleResumeUploadModal(false);
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    } else {
      showWarningMessage("Resume Need to Uploaded");
    }
  };
  const onJoinHMSClick = (eventId, id) => {
    if (id !== null) {
      navigate(`/scheduled-interview/join-new-event/${eventId}/${id}`);
    }
  };

  const onViewDetailsClick = (id) => {
    navigate(
      appRoutes.assessementKit.assignedAssessmentDetail.replace(
        ":assessmentId",
        id
      )
    );
  };
  const getStatusCount = (assessmentData, status) => {
    if (Array.isArray(assessmentData?.status_count)) {
      let statusCount = assessmentData.status_count.filter(
        (item) => item.status === status
      );

      return (statusCount && statusCount[0]?.count) || 0;
    }
    return 0;
  };

  const onTakeAssessmentClick = (id) => {
    navigate(
      appRoutes.assessementKit.previewAssessment.replace(
        ":assignedAssessmentId",
        id
      )
    );
  };

  return {
    assignedAssessmentKits,
    candidateProfile,
    resumeUploadModal,
    scheduledInterviews,
    scheduledInterviewsLoading,
    assignAssesmentKitsLoading,
    interviewInvites,
    interviewInvitesLoading,
 
    onShareProfileClick,
    onStartAssessmentClick,
    onViewAssessmentDetailsClick,
    onTakeAssessmentClick,
    onViewDetailsClick,
    getStatusCount,
    calculatePercentage,
    handleResumeUploadModal,
    onResumeUpload,
    onJoinHMSClick,
    viewScheduleCalenderHandler,
  };
}
export default useCandidateDashboard;
